import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function usePasswordResetConfirmSchema() {
  const { t } = useTranslation();

  return Yup.object().shape({
    password: Yup.string().required(t("label.isRequiredValidation", { field: t("label.password") })),
    passwordConfirmation: Yup.string()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.password"),
        })
      )
      .oneOf([Yup.ref("password"), " s"], t("label.passwordsMustMatch")),
  });
}
